import GameInfo, { useGameInfo } from '@/components/features/casino/game-info';
import { getStaticAsset } from '@/utils/staticAsset';
import { useTranslation } from 'next-i18next';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GameInfoImageWrapper } from '@/components/features/casino/game-info/styles';
import Image from 'next/image';

const InfoContent = styled(Box)(({ theme }) => ({
  maxWidth: '760px',
  fontFamily: 'Work Sans',
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));
export default function RingGameInfo() {
  const { t } = useTranslation();
  const info = [
    // {
    //   type: 'banner',
    //   img: {
    //     src: getStaticAsset('/assets/images/casino/crash-info/banner.png'),
    //     width: 114,
    //     height: 160,
    //     alt: 'moon crash',
    //   },
    //   tag: 'Moonclub Originals',
    //   desc: [
    //     'Prediction multiplier in this quick and easy odds-based game, Crash! Use a variety of different strategies to beat the house.',
    //     'Crash is a simple probability game in which players choose the payout amount for a betting round and the dot representing rockets fly across the grid. As long as the player click crash out before the Crash, the player wins the prize.',
    //   ],
    // },
    {
      type: 'p',
      content:
        'Players can set the Roll Over/Roll Under amount which acts as a target for players to hit and win a round. Setting the numbers to roll over or under controls the Multiplier and Win Chance of the ring in a betting round.',
    },
    {
      type: 'text',
      no: 1,
      content: 'You set the amount you want target using this slider.',
    },
    {
      type: 'image',
      src: getStaticAsset('/assets/images/casino/ring-game/info/slider.png'),
      width: 1434 / 5,
      height: 104 / 5,
      alt: 'slider',
    },
    {
      type: 'text',
      no: 2,
      content:
        'You can switch between Roll Over and Roll Under by clicking on the selected amount.',
    },
    {
      type: 'image',
      src: getStaticAsset('/assets/images/casino/ring-game/info/rollover.png'),
      width: 524 / 3,
      height: 126 / 3,
      alt: 'rollover',
    },
    {
      type: 'image',
      src: getStaticAsset('/assets/images/casino/ring-game/info/rollunder.png'),
      width: 524 / 3,
      height: 126 / 3,
      alt: 'rollunder',
    },
    {
      type: 'text',
      no: 3,
      content: `Click Bet to start the game. `,
    },
    {
      type: 'image',
      src: getStaticAsset('/assets/images/casino/ring-game/info/bet.png'),
      width: 496 / 3,
      height: 72 / 3,
      alt: 'bet',
    },
    {
      type: 'text',
      no: 4,
      content: `Winning and Payouts: If the player's prediction is accurate, they win the game and receive their payout based on the odds and the amount of their bet.`,
    },
    {
      type: 'text',
      no: 5,
      content: `Probability of Winning: The player's probability of winning is determined by how close their predicted number is to the randomly generated number. The closer the prediction is to the actual outcome, the higher the probability of winning.`,
    },
  ];
  const content = useGameInfo(info);
  const img = {
    type: 'image',
    src: getStaticAsset('/assets/images/casino/game-covers/moon-club/ring.png'),
    width: 114,
    height: 114,
    alt: 'moon ring',
  };
  return (
    <GameInfo title={t('Moon Ring Game Description')} gameId={'1004'}>
      <InfoContent>
        <GameInfoImageWrapper
          sx={{
            minWidth: img.width,
            width: img.width,
            height: img.height,
            mr: 2,
            mb: 2,
          }}
        >
          <Image src={img.src} fill alt={img.alt} />
        </GameInfoImageWrapper>
        <Box>{content}</Box>
      </InfoContent>
    </GameInfo>
  );
}
